import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "image",
  "use": "image-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"image\"><path d=\"M38 6H10a4 4 0 00-4 4v28a4 4 0 004 4h28a4 4 0 004-4V10a4 4 0 00-4-4z\" stroke=\"#474B4F\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M17 20a3 3 0 100-6 3 3 0 000 6zM42 30L32 20 10 42\" stroke=\"#474B4F\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol